<script lang="ts">
	//Services
	import { postReq } from 'src/services/http';
	//Helpers
	import { devices_config } from '@devices/index';
	import { get_mode } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';
	//Stores
	import { devices_status, devices_settings } from 'src/stores/device-runtime/status';
	//Types
	import type { Device } from 'src/types/Device';
	import { NotifType } from 'src/types/DeviceNotifPermissions';
	import { onMount } from 'svelte';
	import { testNotifications } from 'src/types/DeviceNotifPermissions';

	//Components
	import PushMailPermissions from './PushMailPermissions.svelte';

	export let device: Device;

	const settings = devices_settings.getByRealId(device.id);
	const status = devices_status.getByRealId(device.id);
	const mode = get_mode(device, status, settings);

	// Notifications in production
	const notifications =
		devices_config[device.type].modes[mode]?.notifications?.filter(
			(notification) =>
				// notification !== 'forgotten_lights' &&
				// notification !== 'device_problem' && // remove 'device problem' from all devices temporary
				/lowBattery/.test(notification) && testNotifications.includes(notification),
		) || [];

	let loading = false;

	onMount(() => {
		notifications.forEach((notification) => {
			// Ensure that device.notif_permissions is defined
			device.notif_permissions = device?.notif_permissions ?? {};
			// Ensure that device.notif_permissions[notification] is defined
			device.notif_permissions[notification] = device?.notif_permissions?.[notification] ?? [1, 1];
		});
		requestEditDevice(device);
	});

	// Used to bind the toggles to the device.notif_permissions object
	$: notifPermissionsBool =
		typeof device?.notif_permissions !== 'undefined'
			? Object.keys(device.notif_permissions)?.reduce((acc, notification) => {
					return {
						...acc,
						[notification]: {
							[NotifType.MAIL]:
								device.notif_permissions[notification][NotifType.MAIL] === 1,
							[NotifType.PUSH]:
								device.notif_permissions[notification][NotifType.PUSH] === 1,
						},
					};
				}, {})
			: {};

	const changeNotificationSetting = async (e) => {
		let notification = e.detail.notification;
		let type = e.detail.notifType;
		device.notif_permissions[notification][type] = device.notif_permissions[notification][type]
			? 0
			: 1;

		loading = true;
		const res = await postReq('interface/device/set_device_notifications', {
			id: device.id,
			set: notification,
			val: device.notif_permissions[notification][type],
			ntype: type,
		});

		if (res.isok) {
			requestEditDevice(device);
		}
		onSettingsResponse(res, device);
		loading = false;
	};
</script>

{#if device?.notif_permissions}
	{#if device?.notif_permissions}
		{#each notifications as notification, i}
			{#if notifPermissionsBool?.[notification]}
				<PushMailPermissions
					mail={notifPermissionsBool[notification][NotifType.MAIL]}
					push={notifPermissionsBool[notification][NotifType.PUSH]}
					{notification}
					{loading}
					{notifPermissionsBool}
					on:changeNotificationSetting={changeNotificationSetting}
				/>
			{/if}
		{/each}
	{/if}
{/if}
